module.exports = __webpack_public_path__ + "media/images/lb/342-07ace0822ffc9fe2561116e9dc86b82f.svg";